import { find, initializeNativeDateTime } from "./lib/dom.js"

const recordButton = find("#start_record")
const content = find("#counsel_content")
const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
let recognizing = false
let recognition = null

initializeNativeDateTime("#counsel_counseled_at")

if (recordButton && content && SpeechRecognition) {
  recognition = new SpeechRecognition()
  recognition.continuous = false
  recognition.lang = "zh-TW"
  recognition.interimResults = true

  recognition.addEventListener("result", (event) => {
    const result = event.results[event.results.length - 1]
    content.value += result[result.length - 1].transcript
  })
  recognition.addEventListener("error", (event) => console.error("語音辨識錯誤", event))
  recognition.addEventListener("end", () => {
    if (recognizing) recognition.start()
  })

  recordButton.addEventListener("click", (event) => {
    event.preventDefault()
    recognizing = !recognizing
    if (recognizing) {
      recognition.start()
      content.value += "開始辨識...\n"
      recordButton.textContent = "暫停收音"
    } else {
      recognition.stop()
      content.value += "停止辨識...\n"
      recordButton.textContent = "開始收音"
    }
  })
} else if (recordButton) {
  recordButton.textContent = "此瀏覽器不支援語音辨識。"
  recordButton.disabled = true
}
